<div class="filter-toolbar">
    <div class="filter-toolbar__filters" [style.min-width]="filtersMinWidthStyle">
        <ng-content select="[filters]"></ng-content>
    </div>
    <div class="filter-toolbar__actions">
        <ng-content select="[actions]"></ng-content>
    </div>
</div>
